var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33336 30.3337H22.6667C28.5467 30.3337 30.3334 28.547 30.3334 22.667V14.667C30.3334 11.6761 29.8711 9.74423 28.6429 8.56791C28.1083 8.05582 27.6667 7.40731 27.6667 6.66699C27.6667 3.44033 25.8934 1.66699 22.6667 1.66699H11.3334H10.6667H9.33336C3.45335 1.66699 1.66669 3.45366 1.66669 9.33366V22.667C1.66669 28.547 3.45335 30.3337 9.33336 30.3337ZM17.3334 6.33366C16.5093 5.23493 17.2933 3.66699 18.6667 3.66699L22.6667 3.66699C24.7734 3.66699 25.6667 4.56033 25.6667 6.66699C25.6667 6.95667 25.4045 7.17563 25.1173 7.13806C24.3933 7.04336 23.5793 7.00033 22.6667 7.00033H18.6667C17.84 7.00033 17.7734 6.92033 17.3334 6.33366ZM26.21 9.39454C25.3744 9.09735 24.2281 9.00033 22.6667 9.00033H18.6667C16.96 9.00033 16.4 8.41366 15.7334 7.53366L13.7334 4.86699C13.04 3.94699 12.8267 3.66699 11.3334 3.66699H9.33336C4.56002 3.66699 3.66669 4.57366 3.66669 9.33366V22.667C3.66669 27.427 4.56002 28.3337 9.33336 28.3337H22.6667C27.44 28.3337 28.3334 27.427 28.3334 22.667V14.667C28.3334 11.7336 27.9941 10.2636 26.6165 9.56736C26.4852 9.50099 26.3405 9.46264 26.21 9.39454Z",
    fill: "url(#paint0_linear_1668_27506)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1668_27506",
    x1: -3.11109,
    y1: 1.66699,
    x2: 30.3334,
    y2: 30.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706855,
    stopColor: "#185B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021744"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder2);
export default __webpack_public_path__ + "static/media/folder-2.7e52c6904729511f82581c725a91090b.svg";
export { ForwardRef as ReactComponent };